module.exports = require("leaflet");


//////////////////
// WEBPACK FOOTER
// external "leaflet"
// module id = 5
// module chunks = 0